module.exports = __webpack_public_path__ + "img/Mask Group (6).643edc88.png";